<template>
	<section id="program" :class="statusClass">
		<header>
			<a href="#" class="sprite ico-calendar">Kalendář</a>
			<h2>Program</h2>
			<div id="calendar">
				<ul>
					<li><a href="" class="active">12.12.</a></li>
					<li><a href="" class="active">12.12.</a></li>
					<li><a href="" class="active">12.12.</a></li>
					<li><a href="">12.12.</a></li>
					<li><a href="">12.12.</a></li>
					<li><a href="">12.12.</a></li>
					<li><a href="">12.12.</a></li>
				</ul>
				<a href="" class="nav nav-prev">Prev</a>
				<a href="" class="nav nav-next">Next</a>
			</div>
			<form id="search">
				<input type="text" placeholder="Lolita">
			</form>
			<a href="#" class="sprite ico-search">Hledani</a>
		</header>
		<h3 class="program__date" v-html="mainHeaderHTML"></h3>
		<div class="content-wrapper">
			<program-item
				v-for="(projection, index) in projections"
				:key="projection.id"
				:projection="projection"
				:index="index"
				@click.native="selectProjection(projection)"
			>
			</program-item>
			<a href="#nacist-vice" class="btn btn--creme more" @click.prevent="loadMore()"><span>{{ loadingCopy }}</span> <i></i></a>
		</div>
		<span class="loading"></span>
	</section>
</template>

<script>
import ProgramItem from '@/components/program/ProgramItem'
import * as s from 'string'
import helpers from '../libs/helpers'

export default {
	name: 'program',
	components: {
		'program-item': ProgramItem
	},
	data () {
		return {
			headings: []
		}
	},
	mounted () {
		const self = this
		self.$('#program .content-wrapper', 0).addEventListener('scroll', function (e) {
			const scrollTop = e.target.scrollTop - self.$('#program h3.program__date', 0).clientHeight // -> offset

			// const heading = self.headings.find(el => scrollTop >= el.offsetTop)
			// const heading = self.headings.reduce((a, b) => a.offsetTop >= scrollTop <= b.offsetTop ? b : a)
			let heading = null
			self.headings.forEach(function (el) {
				heading = scrollTop > el.offsetTop ? el : heading
			})

			if (heading) {
				self.$('#program h3.program__date', 0).innerHTML = heading.element.innerHTML
			} else {
				self.$('#program h3.program__date', 0).innerHTML = self.mainHeaderHTML
			}
		})
	},
	updated () {
		const self = this
		self.headings = []
		self.$('#program .content-wrapper h3').forEach(function (el) {
			self.headings.push({element: el, offsetTop: el.offsetTop})
		})
	},
	computed: {
		projections: function () {
			return this.$store.state.projections
		},
		statusClass: function () {
			return this.$store.state.statuses.projections ? 'active' : 'inactive'
		},
		mainHeaderHTML: function () {
			const date = this.$store.state.programDateHeaderFirst === null ? '' : this.$store.state.programDateHeaderFirst
			const dateName = helpers.nameTheDate(date)
			return `${dateName} <span>${date}</span>`
		},
		loadingCopy: function () {
			return this.$store.state.statuses.projections ? 'Načíst další' : 'Načítám...'
		}
	},
	methods: {
		selectProjection: function (projection) {
			this.$store.commit('projection', projection)
			this.$router.push(`/${s(projection.movie.title).slugify().s}/${projection.id}/`)
		},
		loadMore: function () {
			this.$store.dispatch('loadMore')
		},
		$: (selector, index = null) => {
			const el = document.querySelectorAll(selector)
			if (el) {
				if (el[index]) {
					return el[index]
				}
				return [...el]
			}
			return []
		}
	}
}
</script>

<style lang=less>
	@import "../assets/less/default.less";

	section#program { width: 35vw; border-left: none; border-right: none;
		header { display: flex; justify-content: space-between;
			h2 { width: 80%; overflow: hidden; transition: .33s ease; }
			.ico-search, .ico-calendar { margin-top: 1.5rem; opacity: 0;
				// &:hover { opacity: 1; }
			}
			#search { width: 0%; display: inline-block; overflow: hidden; margin-top: 1.3rem; text-align: center;  transition: .33s ease;
				input { display: inline-block; width: 90%; padding: .5rem; border: none; border-bottom: 2px solid rgba(255, 255, 255, 1); color: white; background-color: transparent;
					&::placeholder { color: white; font-style: italic; }
				}
			}
			#calendar { width: 0%; overflow: hidden; margin-top: 2rem; position: relative; text-align: center; display: flex; justify-content: space-between;
				ul { order: 2; display: inline-block; width: 85%; overflow: hidden; white-space: nowrap; text-align: left; font-size: 0; }
				li { display: inline-block; width: 18%; margin: 0 1%;
					a { width: 100%; display: inline-block; font-size: 11/15rem; padding: 3px; color: @red; background-color: rgba(255, 255, 255, .4); border-radius: 3px; border: 1px solid rgba(255, 255, 255, 0); text-decoration: none; text-align: center;
						&.active { background-color: white; border: 1px solid white; }
						&:hover { border: 1px solid rgba(255, 255, 255, 1);}
					}
				}
				.nav { display: inline-block; .size(12px,12px); text-indent: 100%; white-space: nowrap; overflow: hidden; border-top: 3px solid white; border-left: 3px solid white;
					&-prev { order: 1; transform: rotate(-45deg) translate(3px, 8px); }
					&-next { order: 3; transform: rotate(135deg) translate(8px, 3px); }
				}
			}
			&.program--search {
				h2 { width: 0%;  transition: .33s ease; }
				#search { width: 80%; transition: .33s ease; }
			}
			&.program--calendar {
				h2 { width: 0%;  transition: .33s ease; }
				#calendar { width: 70%; transition: .33s ease; }
			}
		}
		h3 { width: 100%; font-size: 18/15rem; border-bottom: 1px dashed fade(#fff, 40); padding: 0.5rem 0; margin-bottom: 1rem;
			span { float: right; }
		}
		.content-wrapper { height: ~"calc(100vh - 260px)";
			h3 { border-top: 1px dashed fade(#fff, 40); margin-top: 1rem; }
		}
		.more { display: block; width: 60%; margin: 1rem auto .5rem; }
		&.inactive { overflow: hidden;
			@keyframes loading {
				0% { width: 0%; .top-left(0, 0%); }
				10% { width: 10%; .top-left(0, 0%); }
				50% { width: 20%; .top-left(0, 40%); }
				90% { width: 10%; .top-left(0, 100%); }
				100% { width: 0%; .top-left(0, 100%); }
			}
			.loading { position: absolute; display: block; .size(0%, 3px); background-color: #fff; animation: 2s infinite linear loading; }
			.content-wrapper { opacity: .5; }
		}
	}

	@media @tablet {
		section#program { width: 50vw; min-width: 0; border-left: 15px solid @redDark; }
	}

	@media @mobile {
		section#program { width: 100vw; min-width: 0; border-color: @red; }
	}
</style>



// WEBPACK FOOTER //
// src/components/Program.vue